import { Box, Card, CardContent, Chip, Skeleton, Typography } from "@mui/material";
import { COLORS } from "../configs/config";

export const DashCard = ({ title, tag, children, sx = {} }) => (
    <Card sx={{
        bgcolor: COLORS.card,
        border: `0.5px solid ${COLORS.border}`,
        borderRadius: 3,
        height: "100%",
        boxShadow: "none",
        ...sx,
    }}>
        <CardContent>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
                <Typography variant="body2" sx={{ color: COLORS.g1, fontWeight: 600 }}>
                    {title}
                </Typography>
                {tag && (
                    <Typography variant="caption" sx={{
                        color: COLORS.tDim,
                        bgcolor: COLORS.kpiBg,
                        borderRadius: 10,
                        px: 1,
                        py: 0.25,
                    }}>
                        {tag}
                    </Typography>
                )}
            </Box>
            {children}
        </CardContent>
    </Card>
);

export const CardSkeleton = ({ height = 200 }) => (
    <Card sx={{
        bgcolor: COLORS.card,
        border: `0.5px solid ${COLORS.border}`,
        borderRadius: 3,
        height: "100%",
        boxShadow: "none",
    }}>
        <CardContent>
            <Skeleton variant="text" width="60%" sx={{ bgcolor: COLORS.kpiBg, mb: 1 }} />
            <Skeleton variant="rectangular" height={height} sx={{ bgcolor: COLORS.kpiBg, borderRadius: 2 }} />
        </CardContent>
    </Card>
);

export const EpiCard = ({ label, valor, badge, badgeColor, badgeBg, icon, valorColor, frase }) => (
    <Card sx={{
        bgcolor: badgeBg ?? COLORS.kpiBg,
        border: `0.5px solid ${COLORS.border}`,
        borderRadius: 3,
        height: "100%",
        boxShadow: "none",
        transition: "border-color .2s",
        "&:hover": { borderColor: COLORS.g2 },
    }}>
        <CardContent>
            <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={1.5}>
                <Box sx={{
                    width: 36, height: 36, borderRadius: 2,
                    bgcolor: "rgba(0,0,0,0.06)",
                    display: "grid", placeItems: "center",
                    fontSize: 18,
                }}>
                    {icon}
                </Box>
                <Chip
                    label={badge}
                    size="small"
                    sx={{
                        bgcolor: "rgba(0,0,0,0.08)",
                        color: badgeColor,
                        fontWeight: 700,
                        fontSize: 10,
                        height: 22,
                    }}
                />
            </Box>
            <Typography variant="h5" sx={{
                color: valorColor ?? COLORS.tSec,
                fontWeight: 700,
                letterSpacing: -0.5,
            }}>
                {valor}
            </Typography>
            <Typography variant="caption" sx={{ color: COLORS.tDim }}>{label}</Typography>
            <Typography
            sx={{fontSize: 11, marginTop:1, opacity:0.7}}
            >{frase ?? ''}</Typography>
        </CardContent>
    </Card>
);